import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class ExportPdfAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetEmlakBeyanSuret";
        super(baseUrl);
    }
    geExportPdfListe(sqId: string, beyanTuru: string) {
        switch (beyanTuru) {
            case "1":
                beyanTuru = "BINA"
                break;
            case "2":
                beyanTuru = "ARSA"
                break;
            case "3":
                beyanTuru = "ARAZİ"
                break;
        }
        let enRequest: IEnSuretRequest = {
            sqId: sqId,
            beyanTuru: beyanTuru
        };
       
        return this.post("", enRequest, true);
    }
}
export default new ExportPdfAPI();
class ExportPdfListeRequest {
    public sqId: string;

    public BeyanTuru: string;


    constructor(sicilKodu: string, beyanTuru: string) {

        this.sqId = sicilKodu;

        this.BeyanTuru = beyanTuru;


    }


}

interface IEnSuretRequest {
    sqId: string
    beyanTuru: string
}

export type { IEnSuretRequest };